<ng-container [ngSwitch]="definition.type">
  <p *ngSwitchCase="'p'">{{ definition.text }}</p>
  <span *ngSwitchCase="'span'">{{ definition.text }}</span>
  <div *ngSwitchDefault>{{ definition.text }}</div>
</ng-container>
